/**
 * State of the invoice
 */
export enum INVOICE_STATE {
    "APPROVED" = 1,
    "REJECTED" = 2,
    "GERENCIAL" = 3,
    "DEVOLUTIONED" = 4,
    "NOT_DEVOLUTIONED" = 5,
    "CANCELED" = 6,
    "PENDING" = 7,
    "GERENCIAL_DEVOLUTIONED" = 8,
    "DENIED" = 9, /** denegada */
    "USELESS" = 10, /** inutilizada */
    "IMPORTED_VIA_XML" = 11, /** Nota de fornecedor */
    "INPUT_WITHOUT_XML" = 12/** OIM */
}

export const INVOICE_STATE_STR: Record<INVOICE_STATE, string> = {
  [INVOICE_STATE.APPROVED]: 'Nota aprovada',
  [INVOICE_STATE.REJECTED]: 'Nota rejeitada',
  [INVOICE_STATE.GERENCIAL]: 'Operação Interna',
  [INVOICE_STATE.DEVOLUTIONED]: 'Devolução com sucesso',
  [INVOICE_STATE.NOT_DEVOLUTIONED]: 'Devolução com rejeição',
  [INVOICE_STATE.CANCELED]: 'Nota cancelada',
  [INVOICE_STATE.PENDING]: 'Erro',
  [INVOICE_STATE.GERENCIAL_DEVOLUTIONED]: 'Devolução de operação interna',
  [INVOICE_STATE.DENIED]: 'Inutilizada/Denegada',
  [INVOICE_STATE.USELESS]: 'Inutilizada',
  [INVOICE_STATE.IMPORTED_VIA_XML]: 'Nota de fornecedor',
  [INVOICE_STATE.INPUT_WITHOUT_XML]: 'Operação Interna Manual (OIM)'
};
